import { type AnyAction } from 'redux';
import basketActions from '../basket/actions';
import actions from './actions';
import { type ITimeslotsState } from '@/types/timeslots';

export const initialState: ITimeslotsState = {
  basketTimes: [],
  locationTimes: [],
  wantedAt: null,
  loading: false,
  error: false,
};

export const timeslots = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case actions.FETCH_HANDOFF_TIMES_BY_LOCATION:
    case actions.FETCH_HANDOFF_TIMES_BY_BASKET:
      return Object.assign({}, state, {
        loading: true,
      });
    case actions.SET_WANTED_AT:
      return Object.assign({}, state, {
        wantedAt: action.wantedAt,
        error: action.error || initialState.error,
      });
    case actions.FETCH_HANDOFF_TIMES_SUCCESS:
      return Object.assign({}, state, {
        [action.timeslotType]: action.timeslots,
        loading: false,
      });
    case actions.FETCH_HANDOFF_TIMES_FAILURE:
      return Object.assign({}, state, {
        loading: false,
      });
    case actions.CLEAR_HANDOFF_TIMES:
      return initialState;
    /**
     * `wantedAt` is basket-scoped and must die with the basket. `initializeOrderSaga`'s ASAP
     * gate (TEAM-14375) reads it as the witness that the server still holds a scheduled time,
     * and nothing else resets it — `CLEAR_HANDOFF_TIMES` has no dispatch site and redux
     * outlives sessionStorage. Without these cases a time scheduled on one basket survives
     * the order being submitted (`DESTROY_BASKET`) or a new basket being started
     * (`INIT_NEW_BASKET`), and the next ASAP checkout entry fires the `DELETE /wanted-time`
     * that gate exists to skip — on a basket that has never held a time.
     */
    case basketActions.DESTROY_BASKET:
    case basketActions.INIT_NEW_BASKET:
      return Object.assign({}, state, {
        wantedAt: initialState.wantedAt,
        error: initialState.error,
      });
    default:
      return state;
  }
};
